"use strict";
// @ts-ignore
try {
    self['workbox:recipes:6.5.3'] && _();
}
catch (e) { }
